<template>
    <v-container class="toggle animated" v-show="compliance == null" fluid>
        <v-row v-if="compliancesData.length == 0" class="fill-height">
            <v-col class="d-flex justify-center mt-16">
                <v-card align="center" class="mt-16" elevation="0">
                    <v-icon size="200">
                        mdi-calendar-alert
                    </v-icon>
                    <v-card-text class="text-button">
                        No Schedule Created for Compliance
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col v-for="compliance in compliancesData" :key="compliance" cols="12" xl="4" md="6">
                <v-card @click="showCompliance(compliance)" class="pa-2 d-flex flex-column fill-height" elevation="3">
                    <v-card-text>
                        <div class="text-h6 font-weight-black">{{ compliance.compliance_name }}</div>
                        <div class="text-body-2 font-weight-bold mt-4">Schedules</div>
                        <v-row class="mt-2" dense v-for="schedule in compliance.schedules" :key="schedule">
                            <v-col v-if="compliance.is_term_separated" cols="12">
                                <b>{{ schedule.term.name }}</b>
                            </v-col>
                            <v-col cols="12" md="6">
                                Deadline: <b>{{ formatDate(schedule.deadline) }}</b>
                            </v-col>
                            <v-col v-if="schedule.is_extended" cols="12" md="6">
                                Deadline Extension: <b>{{ formatDate(schedule.deadline_extension) }}</b>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    <v-container fluid class="toggle animated" v-show="compliance !== null">
        <div class="d-flex flex-column flex-md-row justify-start align-left justify-md-space-between align-md-center mb-4 ga-2">
            <v-btn
                prepend-icon="mdi-chevron-left"
                @click="compliance = null"
                class="rounded-lg"
                color="grey-darken-1"
                height="40px"
                elevation="2">
                    Back
            </v-btn>
            <div class="font-weight-bold text-h6">
                {{ title }}
            </div>
        </div>
        <CompliancesCheckingDetails ref="CompliancesCheckingDetails"/>
    </v-container>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import CompliancesCheckingDetails from '../Sub-Parent/DeansComplianceCheckingDetails.vue';

export default defineComponent({
    components: {
        CompliancesCheckingDetails
    },
    data(){
        return {
            compliance: null,
            title: null,
            loading: false,
            compliancesData: []
        }
    },
    methods: {
        init(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/compliances/findAllComplianceWithoutUploadAndWithSchedule/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.compliancesData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        showCompliance(data){
            this.compliance = data
            this.title = data.compliance_name
            this.$refs.CompliancesCheckingDetails.init(data)
        },
    },
    mounted(){
        this.init()
    },
})
</script>

<style scoped>

</style>